/**
 * Pure presentation helpers for the Todo (Task) feature.
 * No React / no side effects — safe to share across views.
 */

// Re-exported so views can import everything todo-related from "../helpers".
export { getEmployeeImageUrl } from "../services/todoCommanService";

/** Capitalise + truncate a task title for compact display. */
export function formatTitle(text: string, maxChars = 30): string {
  if (!text) return "";
  const trimmedText = text.trim();
  if (trimmedText.length <= maxChars) {
    return trimmedText.charAt(0).toUpperCase() + trimmedText.slice(1);
  }
  const truncatedText = trimmedText.slice(0, maxChars);
  return truncatedText.charAt(0).toUpperCase() + truncatedText.slice(1) + "...";
}

/** Capitalise the first letter of a string. */
export const capitalizeFirstLetter = (str: string): string => {
  if (!str) return "";
  return str.charAt(0).toUpperCase() + str.slice(1);
};

/** Map a task stage to a completion percentage (List view progress ring). */
export const getProgress = (stage: number): number => {
  switch (stage) {
    case 0: // Pending
      return 0;
    case 1: // Inprogress
      return 50;
    case 2: // Onhold
      return 25;
    case 3: // Completed
      return 100;
    default:
      return 0;
  }
};

/** Bootstrap badge class for a tag (Grid view). */
export const getTagClass = (tag: string): string => {
  switch (tag.toLowerCase()) {
    case "projects":
      return "badge-success";
    case "internal":
      return "badge-danger";
    case "reminder":
      return "badge-secondary";
    case "social":
      return "badge-info";
    default:
      return "badge-secondary";
  }
};

/** Bootstrap badge class for a stage label (Grid view). */
export const getStageClass = (stage: string): string => {
  switch (stage) {
    case "Pending":
      return "badge-secondary-transparent";
    case "Inprogress":
      return "bg-transparent-purple";
    case "Onhold":
      return "bg-soft-pink";
    case "Completed":
      return "badge-soft-success";
    default:
      return "badge-secondary-transparent";
  }
};

/** Bootstrap button class for the inline stage dropdown (List view). */
export const getStageButtonClass = (stage: number): string => {
  return stage === 0
    ? "btn-secondary"
    : stage === 1
      ? "btn-warning"
      : stage === 2
        ? "btn-primary"
        : stage === 3
          ? "btn-info"
          : stage === 4
            ? "btn-purple"
            : "btn-success";
};
